import { getCookie } from '../../hookServices/cookiesManager';

const EARTH_RADIUS_KM = 6371;

export function haversineDistanceKm(from, to) {
  const [lng1, lat1] = from;
  const [lng2, lat2] = to;
  const r = Math.PI / 180;
  const dLat = (lat2 - lat1) * r;
  const dLng = (lng2 - lng1) * r;
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * r) * Math.cos(lat2 * r) * Math.sin(dLng / 2) ** 2;
  return EARTH_RADIUS_KM * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
}

export function getSearchReferenceLngLat() {
  try {
    const userLocation = getCookie('userLocation');
    if (userLocation?.latitude != null && userLocation?.longitude != null) {
      const { latitude, longitude } = userLocation;
      if (Number.isFinite(latitude) && Number.isFinite(longitude)) {
        return [longitude, latitude];
      }
    }
  } catch (_e) {
    // ignore
  }

  try {
    const savedCenter = sessionStorage.getItem('mapCenter');
    if (savedCenter) {
      const [lng, lat] = JSON.parse(savedCenter);
      if (Number.isFinite(lng) && Number.isFinite(lat)) {
        return [lng, lat];
      }
    }
  } catch (_e) {
    // ignore
  }

  return [31.223, 49.454];
}

export function buildGoogleMapsNavigationUrl(latitude, longitude) {
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }
  return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;
}

export function buildWazeNavigationUrl(latitude, longitude) {
  const lat = parseFloat(latitude);
  const lng = parseFloat(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
    return null;
  }
  return `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
}

const EVUA_STATION_DEEPLINK_BASE = 'https://evua.site/station/';

export function evuaStationKey(port) {
  if (port?.key != null && String(port.key).trim() !== '') return String(port.key).trim();
  if (port?.number != null && String(port.number).trim() !== '') return String(port.number).trim();
  return '';
}

export function buildEvuaStationUrl(stationKey) {
  if (stationKey == null || stationKey === '') {
    return null;
  }
  return `${EVUA_STATION_DEEPLINK_BASE}${stationKey}`;
}

export function findNearestMatchingPorts(ports, query, referenceLngLat, limit = 5) {
  const q = String(query ?? '').trim();
  if (!q || !Array.isArray(ports) || ports.length === 0) {
    return [];
  }

  return ports
    .filter(port => String(port?.number ?? '').includes(q))
    .map(port => {
      const lng = parseFloat(port.longitude);
      const lat = parseFloat(port.latitude);
      const distanceKm =
        Number.isFinite(lng) && Number.isFinite(lat) ? haversineDistanceKm(referenceLngLat, [lng, lat]) : Infinity;
      return { port, distanceKm };
    })
    .sort((a, b) => a.distanceKm - b.distanceKm)
    .slice(0, limit)
    .map(({ port, distanceKm }) => ({ ...port, distanceKm }));
}
